// src/TranslateWidget.js
import { useEffect } from 'react';

export const googleReady = { current: false }; // shared flag

const TranslateWidget = () => {
    useEffect(() => {
        if (window.google?.translate) {
            googleReady.current = true;
            return;
        }

        // script दुबारा न जुड़े
        if (!document.getElementById('gt-script')) {
            const s = document.createElement('script');
            s.id = 'gt-script';
            s.src =
                'https://translate.google.com/translate_a/element.js?cb=__gtInit';
            s.async = true;
            document.body.appendChild(s);
        }

        // global callback
        window.__gtInit = () => {
            new window.google.translate.TranslateElement(
                { pageLanguage: 'en', autoDisplay: false },
                'google_translate_element'
            );
            googleReady.current = true;                 // ✅ ready!
        };
    }, []);

    return <div id="google_translate_element" style={{ display: 'none' }} />;
};

export default TranslateWidget;
